import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Check if the app was pre-rendered by react-snap
// If so, use hydration to attach React to the existing HTML
if (container.hasChildNodes()) {
  hydrateRoot(container, 
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Enable react-snap crawling
if (typeof navigator !== 'undefined' && navigator.userAgent.match(/ReactSnap/)) {
  // Ensure all dynamic content is loaded before snapshot
  window.snapSaveState = () => ({
    __PRELOADED_STATE__: {}
  });
}
